import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { Table, TableHeader, TableCell, TableRow, TitleCell } from './JoinInfoForGuest.style';
import MainLayout from '../../components/Layouts/Main/MainLayout.index';
import { useNavigate } from 'react-router-dom';
import { getDaikaiParticipants } from "../../api/project";

const JoinInfoForGuest = () => {
  const [infoList, setInfoList] = useState([]);
  const [filteredInfoList, setFilteredInfoList] = useState([]);

  // 🔍 各項目フィルター
  const [filterDate, setFilterDate] = useState('');
  const [filterTitle, setFilterTitle] = useState('');
  const [filterUserName, setFilterUserName] = useState('');
  const [filterWantName, setFilterWantName] = useState('');
  const [filterTel, setFilterTel] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterMemo, setFilterMemo] = useState('');
  const [totalFans, setTotalFans] = useState(0);
  const [filteredFans, setFilteredFans] = useState(0);
  const navigate = useNavigate();


  useEffect(() => {
  // 全体件数
  const total = infoList.reduce((sum, event) => sum + event.joinList.length, 0);
  setTotalFans(total);

  // フィルター後件数
  const filtered = filteredInfoList.reduce((sum, event) => sum + event.joinList.length, 0);
  setFilteredFans(filtered);
}, [infoList, filteredInfoList]);


  useEffect(() => {
    const fetchData = async () => {
      const res = await getDaikaiParticipants();
      for (let index = 0; index < res.data?.length; index++) {
        if (res.data[index].daikai_title2 !== "" && 
              sessionStorage.getItem('daikai_title2') !== ""  &&
              res.data[index].daikai_title2.includes(sessionStorage.getItem('daikai_title2'))) {
          setInfoList(res.data);
          setFilteredInfoList(res.data);
        }
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const userId = sessionStorage.getItem('userId');
    if (!userId) {
        navigate('/');
        return;
    }
    const newFiltered = infoList.map(event => {
      const matchDate = !filterDate || event.date_time.includes(filterDate);
      const matchTitle = !filterTitle || event.daikai_title2.includes(filterTitle);
      if (!matchDate || !matchTitle) return null;

      const filteredJoinList = event.joinList.filter(joinInfo => {
        let other = {};
        try {
          other = joinInfo.other_json_item ? JSON.parse(joinInfo.other_json_item) : {};
        } catch {}

        const matchUser = !filterUserName || (joinInfo.user_name || '').includes(filterUserName);
        const matchWant = !filterWantName || (other.wantName || '').includes(filterWantName);
        const matchTel = !filterTel || (other.tel || '').includes(filterTel);
        const matchEmail = !filterEmail || (joinInfo.email || '').includes(filterEmail);
        const matchMemo = !filterMemo || (other.daikaiMemo || joinInfo.daikai_memo || '').includes(filterMemo);

        return matchUser && matchWant && matchTel && matchEmail && matchMemo;
      });

      return { ...event, joinList: filteredJoinList };
    }).filter(event => event && event.joinList.length > 0);

    setFilteredInfoList(newFiltered);
  }, [filterDate, filterTitle, filterUserName, filterWantName, filterTel, filterEmail, filterMemo, infoList, navigate]);

  const handleClear = () => {
    setFilterDate('');
    setFilterTitle('');
    setFilterUserName('');
    setFilterWantName('');
    setFilterTel('');
    setFilterEmail('');
    setFilterMemo('');
  };

  const exportToExcel = () => {
    const excelData = [];

    filteredInfoList.forEach(event => {
      event.joinList.forEach(joinInfo => {
        let other = {};
        try {
          other = joinInfo.other_json_item ? JSON.parse(joinInfo.other_json_item) : {};
        } catch {}

        excelData.push({
          開催日: event.date_time,
          大会回: event.daikai_title1,
          大会タイトル: event.daikai_title2,
          申込者名雀活マスター: joinInfo.user_name || '',
          申込者名当日: other.wantName || '',
          電話番号: other.tel || '',
          メール: joinInfo.email || '',
          同卓希望プロ: other.sameTablePro || '',
          メモ: other.daikaiMemo || joinInfo.daikai_memo || ''
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '大会参加者一覧');
    XLSX.writeFile(workbook, '大会参加者一覧.xlsx');
  };

  return (
    <MainLayout>
      <div style={{ marginBottom: '10px', textAlign: 'left', color: '#008000' }}>
        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
          ファン-大会参加者一覧
        </span>
      </div>

      {/* 絞り込み条件 */}
      <div style={{ marginBottom: '10px', textAlign: 'left', fontStyle: 'italic' }}>
        <span style={{ fontSize: '13px' }}>絞り込み条件</span>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
        <input placeholder="開催日" value={filterDate} onChange={e => setFilterDate(e.target.value)} />
        <input placeholder="大会タイトル" value={filterTitle} onChange={e => setFilterTitle(e.target.value)} />
        <input placeholder="申込者(雀活マスターの利用名)" value={filterUserName} onChange={e => setFilterUserName(e.target.value)} />
        <input placeholder="申込者(活動の際の利用名)" value={filterWantName} onChange={e => setFilterWantName(e.target.value)} />
        <input placeholder="電話番号" value={filterTel} onChange={e => setFilterTel(e.target.value)} />
        <input placeholder="メール" value={filterEmail} onChange={e => setFilterEmail(e.target.value)} />
        <input placeholder="メモ" value={filterMemo} onChange={e => setFilterMemo(e.target.value)} />
        <button onClick={handleClear}>クリア</button>
        <button onClick={exportToExcel}>Excel出力</button>
      </div>

      <div style={{ marginBottom: '0.1px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
        <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
        📊 全参加者数：{totalFans} 件 ／ フィルター結果：{filteredFans} 件
        </span>
      </div>


      <Table>
        <thead>
          <tr>
            <TableHeader>大会情報</TableHeader>
            <TableHeader>申込者(雀活マスターの利用名)</TableHeader>
            <TableHeader>申込者(活動の際の利用名)</TableHeader>
            <TableHeader>電話番号</TableHeader>
            <TableHeader>E-Mail</TableHeader>
            <TableHeader>同卓希望プロ</TableHeader>
            <TableHeader>メモ</TableHeader>
          </tr>
        </thead>
        <tbody>
          {filteredInfoList.map((item, index) => (
            <React.Fragment key={index}>
              <TableRow>
                <TableCell rowSpan={item.joinList.length + 1}>
                  {item.date_time}<br />
                  {item.daikai_title1}<br />
                  {item.daikai_title2}
                </TableCell>
              </TableRow>
              {item.joinList.map((joinInfo, subIndex) => {
                let other = {};
                try {
                  other = joinInfo.other_json_item ? JSON.parse(joinInfo.other_json_item) : {};
                } catch {}

                return (
                  <TableRow key={`${index}-${subIndex}`}>
                    <TitleCell>{joinInfo.user_name || ''}</TitleCell>
                    <TitleCell>{other.wantName || ''}</TitleCell>
                    <TitleCell>{other.tel || ''}</TitleCell>
                    <TitleCell>{joinInfo.email || ''}</TitleCell>
                    <TitleCell>{other.sameTablePro || ''}</TitleCell>
                    <TitleCell>{other.daikaiMemo || joinInfo.daikai_memo || ''}</TitleCell>
                  </TableRow>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </MainLayout>
  );
};

export default JoinInfoForGuest;
